import { useMutation, UseMutationResult } from "react-query";
import { gql, ClientError } from "graphql-request";
import { graphQLClient, __DEV__ } from "../api";

export function useSendCardUpdateEmail(): UseMutationResult<
  GQL.UsersSendCardUpdateEmail,
  ClientError,
  GQL.MutationUsersSendCardUpdateEmailArgs
> {
  return useMutation(
    async (dataMutation) => {
      const overrideEmailParam = dataMutation.overrideEmail
        ? `overrideEmail: "${dataMutation.overrideEmail}",`
        : "";
      const data = await graphQLClient.request(
        gql`
            mutation {
              usersSendCardUpdateEmail(
                stripeCustomerId: "${dataMutation.stripeCustomerId}",
                ${overrideEmailParam}
              ) {
                status
                message
              }
            }
        `
      );
      if (__DEV__) {
        console.log(data);
      }
      return data.usersSendCardUpdateEmail;
    },
    {
      onSuccess: (data, variables, context) => {},
      onError: (error: ClientError, variables, context) => {},
    }
  );
}
